// extracted by mini-css-extract-plugin
export default {"card":"index_card__w2V8R","tree":"index_tree__A2tmv","ant-btn":"index_ant-btn__zHbgl"};